import Table from '@/common/components/Table'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { useNavigate, useParams } from 'react-router-dom'
import { useClientEquipmentLastUsageDeclarationsPerCategory } from '../../hooks/equipments/useClientEquipmentLastUsageDeclarationsPerCategory';
import { EquipmentLastUsageDeclarationsPerCategoryTransformer } from '../../services/equipments/equipmentLastUsageDeclarationsPerCategoryTransformer';
import { CompanyEquipmentData } from '../../types/companyEquipments.type';
import { lastUsageDeclarationPerCategoryTableColumns } from '../../constants/equipments/lastUsageDeclarationsPerCategoryTableColumns.constant';
import Button from '@/common/components/Button';

interface ClientEquipmentLastUsageDeclarationsPerCategoryProps {
  equipment?: CompanyEquipmentData;
}

export const ClientEquipmentLastUsageDeclarationsPerCategory = ({ equipment }: ClientEquipmentLastUsageDeclarationsPerCategoryProps) => {
  const { id: equipmentId, companyId } = useParams()
  const navigate = useNavigate()

  const { filterParams, setFilterParams } = useFilterParams();

  const {
    data: equipmentLastUsageDeclarationsPerCategory,
    meta: equipmentLastUsageDeclarationsPerCategoryMeta,
    isPending: equipmentLastUsageDeclarationsPerCategoryIsPending,
  } = useClientEquipmentLastUsageDeclarationsPerCategory({
    equipmentId,
    filters: {
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EquipmentLastUsageDeclarationsPerCategoryTransformer.tableTransformer(equipment),
    }),
  })

  return (
    <div className="flex flex-col gap-6 flex-1 overflow-auto">
      <Button 
        className='self-end'
        onClick={() => navigate(`/companies/${companyId}/equipments/${equipmentId}/equipmentUsageDeclarationsHistory`)}
      >
        Histórico de uso
      </Button>
      <Table
        className="max-h-[calc(100vh-192px)]"
        columns={lastUsageDeclarationPerCategoryTableColumns}
        isLoadingData={equipmentLastUsageDeclarationsPerCategoryIsPending}
        rows={equipmentLastUsageDeclarationsPerCategory}
        rowEmptyValue="--"
        page={filterParams.page || 1}
        setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        totalPages={equipmentLastUsageDeclarationsPerCategoryMeta.total_pages}
        totalCount={equipmentLastUsageDeclarationsPerCategoryMeta.total}
        hasPagination
      />
    </div>
  )
}
